export function formatNoteDate(isoString) {
  if (!isoString) return "";
  
  try {
    const d = new Date(isoString);
    
    // ✅ Validate the Date object with isNaN(d.getTime())
    if (isNaN(d.getTime())) {
      console.warn('Invalid date string provided to formatNoteDate:', isoString);
      return "Invalid Date";
    }
    
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
  } catch (error) {
    console.warn('Error formatting date:', isoString, error);
    return "Invalid Date";
  }
}

export function combineDateTime(date, time) {
  // ✅ Add fallback handling if time is missing or malformed
  if (!date) {
    console.warn('No date provided to combineDateTime');
    return null;
  }
  
  if (!time) {
    console.warn('No time provided to combineDateTime, using midnight');
    // Return date at midnight if no time provided
    try {
      const combined = new Date(date);
      if (isNaN(combined.getTime())) {
        console.warn('Invalid date provided to combineDateTime:', date);
        return null;
      }
      combined.setHours(0, 0, 0, 0);
      return combined;
    } catch (error) {
      console.warn('Error creating date from date parameter:', date, error);
      return null;
    }
  }
  
  try {
    const combined = new Date(date);
    
    // Validate the base date
    if (isNaN(combined.getTime())) {
      console.warn('Invalid date provided to combineDateTime:', date);
      return null;
    }
    
    // Validate the time object
    if (!time.getHours || !time.getMinutes) {
      console.warn('Invalid time object provided to combineDateTime:', time);
      return combined; // Return date without time modification
    }
    
    combined.setHours(time.getHours());
    combined.setMinutes(time.getMinutes());
    return combined;
  } catch (error) {
    console.warn('Error combining date and time:', date, time, error);
    return null;
  }
}

export function parseLocalDate(isoString) {
  // ✅ Ensure parseLocalDate handles empty or invalid ISO strings
  if (!isoString || typeof isoString !== 'string') {
    console.warn('Invalid or empty ISO string provided to parseLocalDate:', isoString);
    return new Date(); // Return current date as fallback
  }
  
  try {
    // Handle various ISO string formats
    let processedString = isoString.trim();
    
    // Remove 'Z' suffix if present (UTC indicator)
    if (processedString.endsWith('Z')) {
      processedString = processedString.replace("Z", "");
    }
    
    const date = new Date(processedString);
    
    // Validate the parsed date
    if (isNaN(date.getTime())) {
      console.warn('Failed to parse ISO string as valid date:', isoString);
      return new Date(); // Return current date as fallback
    }
    
    return date;
  } catch (error) {
    console.warn('Error parsing local date:', isoString, error);
    return new Date(); // Return current date as fallback
  }
}